import { baseApi } from '@/features/api/baseApi';
import { logoutDirectusSession } from '@/features/api/directus';
import { loginRedirectUrl, useOidc } from '@/shared/auth/oidc';
import { getUserDisplayName } from '@/shared/utils/oidc.utils';
import { Alert, Box, Button, Card, Group, Stack, Text, Title } from '@mantine/core';
import { useTranslate } from '@tolgee/react';
import { Link as RouterLink } from 'react-router-dom';

const LoginPage = () => {
  const { t } = useTranslate();
  const oidc = useOidc();

  const handleLogout = async () => {
    if (!oidc.isUserLoggedIn) return;

    await logoutDirectusSession();
    baseApi.util.resetApiState();
    oidc.logout({ redirectTo: 'home' });
  };

  return (
    <Box maw={560} mx="auto">
      <Card radius="lg" withBorder>
        <Stack gap="md">
          <Text size="xs" c="dimmed" tt="uppercase" fw={700}>
            {t('login.overline')}
          </Text>
          <Title order={1}>{t('login.title')}</Title>
          <Text c="dimmed">
            {oidc.isUserLoggedIn ? t('login.alreadyLoggedIn') : t('login.description')}
          </Text>
          {oidc.isUserLoggedIn ? (
            <Alert color="green">
              {t('auth.loggedInAs', { name: getUserDisplayName(oidc.decodedIdToken) })}
            </Alert>
          ) : (
            <Alert color="blue">{t('login.providerHint')}</Alert>
          )}
          <Group justify="flex-end" gap="sm" wrap="wrap">
            <Button component={RouterLink} to="/" variant="subtle">
              {t('login.backHome')}
            </Button>
            {oidc.isUserLoggedIn ? (
              <Button variant="outline" color="gray" onClick={handleLogout}>
                {t('auth.logout')}
              </Button>
            ) : (
              <Button onClick={() => void oidc.login({ redirectUrl: loginRedirectUrl })}>
                {t('auth.signIn')}
              </Button>
            )}
          </Group>
        </Stack>
      </Card>
    </Box>
  );
};

export default LoginPage;
